import React from 'react';
import AuthService from './authService';

class OfficeCostGroupLinkService extends React.Component
{
  static GetOfficeCostGroupLinks (officeId)
  {
    return AuthService.getInstance().CallBackendFunction(
      `/api/OfficeCostGroupLink/GetOfficeCostGroupLinks/${officeId}`
    );
  }

  static EditOfficeCostGroupLink (resource)
  {
    const json = JSON.stringify(resource);
    return AuthService.getInstance().CallBackendFunctionPut('/api/OfficeCostGroupLink/EditOfficeCostGroupLink', json);
  }
}

export default OfficeCostGroupLinkService;
